import { FunctionComponent } from 'react';
import classnames from 'classnames';

import { getOptionValue } from 'utils/option';

import StyledComponent from './styles';
import { Props } from './types';

const LayoutOptionSelector: FunctionComponent<Props> = ({ options, onSelect, selectedOption }) => {
    return (
        <StyledComponent className="layout-option-selector">
            {options.map(option => (
                <div
                    className={classnames(
                        'option',
                        { selected: getOptionValue(selectedOption) === getOptionValue(option) }
                    )}
                    key={getOptionValue(option)}
                    onClick={() => onSelect(option)}
                >
                    {option.label}
                </div>
            ))}
        </StyledComponent>
    );
};

export default LayoutOptionSelector;